import I18n from '../../config/i18n';

interface CountryNameProps {
  countryCode: string;
}

export default function CountryName({ countryCode }: CountryNameProps): JSX.Element {
  const countryMap: { [key: string]: string } = {
    DE: 'germany',
    BE: 'belgium',
    FR: 'france',
    NL: 'nederland',
    UK: 'great_britain',
    ES: 'spain',
    SE: 'sweden',
    NO: 'norway',
    DK: 'danemark',
    AT: 'austria',
    CH: 'switzerland',
    PT: 'portugal',
    IT: 'italy',
    LU: 'luxemburg',
  };

  return <>{I18n.t(`homepage.subscription_form.country.${countryMap[countryCode]}`)}</>;
}
